axios.defaults.baseURL = '/api/cosmos';
// const api = '/api/cosmos'

var Api = {
  // auth
  Login: '/auth/login',
  Logout: '/auth/logout',
  // realtime page
  GetFactoriesInfo: '/factoriesinfo/getFactoriesInfo',
  GetAllAlarms: '/factories/getAllAlarms',
  GetFactoryError: '/realtime/factoryError',
  GetLastSpecificDocuments: '/factories/getLastSpecificDocuments',
  // foreign factory list
  GetOtherSystemFactories: '/factories/getOtherSystemFactories',
  // factories
  GetLastDocument: '/factories/getLastDocument',
  // siteinfo - siteinfodetail page
  GetRecentThirtyDays: '/siteinfo/getRecentThirtyDays',
  GetHours: '/siteinfo/getHours',
  GetDays: '/siteinfo/getDays',
  GetMonth: '/siteinfo/getMonth',
  GetYear: '/siteinfo/getYear',
  GetInvs: '/siteinfo/getInvs',
  // tv screen page
  GetLinkGroup: '/siteinfo/getLinkGroup',
  GetLinkData: '/siteinfo/getLinkData',
  GetLinkBlob: '/siteinfo/getLinkBlob',
  // siteinfo - devicehistory page
  GetDeviceHistory: '/devicehistory/getDeviceHistory',
  // siteinfo - dataanalysis page
  GetIntervalAnalysis: '/dataanalysis/getIntervalAnalysis',
  GetAllAnalysisData: '/dataanalysis/getAllAnalysisData',
  GetAnalysisAvailability: '/dataanalysis/getavailability',
  GetAvailabilityRemark: '/dataanalysis/getavailabilityremark',
  UpdateAvailabilityRemark: '/dataanalysis/setavailabilityremark',
  // siteinfo - mpptanalysis page
  GetMpptLen: '/multplemppt/getmpptlen',
  GetMpptData: '/multplemppt/getmpptdata',
  // siteinfo - dataexcel page
  CreateKpiTable: '/dataanalysis/createkpitable',
  GetKpiTable: '/dataanalysis/getkpitable',
  GetPdf: '/siteinfo/getpdf',
  GetCsv: '/siteinfo/getcsv',
  UpdateCsv: '/siteinfo/updatecsv',
  DeletePdf: '/siteinfo/deletepdf',
  // siteinfo - investmentanalysis page
  GetPowerAmount: '/investment/poweramount',
  GetPowerRevenue: '/investment/powerRevenue',
  GetAvailability: '/investment/availability',
  GetPerformantRate: '/investment/performantRate',
  GetBills: '/investment/getbills',
  GetWriteBills: '/investment/writebills',
  GetDataRetention: '/investment/dataretention',
  // siteinfo - monthlyreport page
  // month
  GetMonSumTable: '/monthreport/monsumtable',
  GetDaysTable: '/monthreport/daystable',
  GetDaysChart: '/monthreport/dayschart',
  // year
  GetYearSumTable: '/yearreport/yearsumtable',
  GetMonthsTable: '/yearreport/montable',
  GetMonthsChart: '/yearreport/monchart',
  // siteinfo - notificationsettings
  GetCustomAlarm: '/customalarm/get',
  GetCustomAlarmGroup: '/customalarm/getGroup',
  UpdateCustomAlarm: '/customalarm/update',
  // siteinfo - DIDO
  GetDido: '/dido/get',
  WriteDido: '/dido/write',
  UpdateDido: '/dido/update',
  DirectMethodDido: '/dido/dm',
  DeleteDido: '/dido/delete',
  // factoryStatus page
  GetRecentAlarms: '/devicestatus/recentalarms',
  UpdateDeviceConfig: '/devicestatus/updatedeviceconfig',
  GetLastEtcData: '/devicestatus/getlastetcdata',
  // historyalarms page
  GetHistoryAlarms: '/devicestatus/historyalarms',
  // usermanage page
  GetAllUsers: '/usermanage/getallusers',
  CreateUser: '/usermanage/createuser?operator=',
  UpdateAccount: '/usermanage/updateaccount?operator=',
  DeleteUser: '/usermanage/deleteuser?operator=',
  // groupmanage page
  GetAllGroups: '/groupmanage/getallgroups',
  CreateGroup: '/groupmanage/creategroup?operator=',
  UpdateGroup: '/groupmanage/updategroup?operator=',
  DeleteGroup: '/groupmanage/deletegroup?operator=',
  // emailsend page
  GetDailyReportList: '/reportresend/dailyreportlist',
  GetDailyReport: '/reportresend/getdailyreport',
  GetSendMails: '/reportresend/sendmails',
  // multiplefactoryanalysis page
  GetMultipleHourData: '/multplefactory/getmultiplehourdata',
  GetMultipleDayData: '/multplefactory/getmultipledaydata',
  GetMultipleMonthData: '/multplefactory/getmultiplemonthdata',
  GetMultipleYearData: '/multplefactory/getmultipleyeardata',
  // rawdatadownload page
  GetRawData: '/rawdata/getrawdata',
  // raanalysis page
  GetPvRa: '/pvra/get',
  // aerialcomparison page 空拍比對資料下載
  GetAerialComparison: '/aerialcomparison/get',
  // kpi month report page
  GetKpi: '/kpi/table',
  // 富強鑫展示頁面
  GetFuqiangxin: '/fcs/compose',
  // 案場排序
  GetSortedFactories: '/factories/getSortedFactories',
  UpdateSortedFactories: '/factories/writeSortedFactories',
  // 電視牆輪播
  Get14fSelected: '/siteinfo/selected14fData',
  Get14fData: '/siteinfo/14f'
};

// --------------------------------------------------------
// ------------------------- auth -------------------------
// --------------------------------------------------------
/**
 * login
 * @param {string} account 'test'
 * @param {string} password test
 * @returns data: { some user's information }, msg: 'logged in'
 */
export var loginApi = function loginApi(account, password) {
  return axios.post(Api.Login, {
    account: account,
    password: password
  });
};

/**
 * logout
 * @returns msg: 'logged out'
 */
export var logoutApi = function logoutApi() {
  return axios.post(Api.Logout);
};

// -------------------------------------------------------------
// ------------------------- realtime --------------------------
// -------------------------------------------------------------
/**
 * 案場名稱清單 取得 案場清單資訊 [ info ]
 * @param {string[]} factoriesList ['','']
 */
export var getFactoriesInfoApi = function getFactoriesInfoApi(factoriesList) {
  return axios.post(Api.GetFactoriesInfo, {
    factoriesList: factoriesList
  });
};

/**
 * 案場名稱清單 取得 所有案場狀態數量
 */
export var getAllAlarmsApi = function getAllAlarmsApi() {
  return axios.post(Api.GetAllAlarms);
};

/**
 * 案場告警
 * @param {string} startDate '2023-02-08'
 * @param {string} endDate '2023-02-08'
 * @param {string} factoryName 'all' | '鳳山圳滯洪池'
 * @param {string} factoryId 'all' | 'f001'
 */
export var getFactoryErrorApi = function getFactoryErrorApi(startDate, endDate, factoryName, factoryId) {
  return axios.post(Api.GetFactoryError, {
    startDate: startDate,
    endDate: endDate,
    factoryName: factoryName,
    factoryId: factoryId
  });
};

/**
 * 案場資訊 [ info ] 取得 案場詳細資料 [ data ]
 * @param {Array<object>} factoriesInfoArray [{},{}]
 */
export var getLastSpecificDocumentsApi = function getLastSpecificDocumentsApi(factoriesInfoArray) {
  return axios.post(Api.GetLastSpecificDocuments, factoriesInfoArray);
};

// -------------------------------------------------------------
// ------------------- foreign factories -----------------------
// -------------------------------------------------------------
/**
 * 取得 外來監控 list
 */
export var getOtherSystemFactoriesApi = function getOtherSystemFactoriesApi() {
  return axios.post(Api.GetOtherSystemFactories);
};

// -------------------------------------------------------------
// ------------------------- factories -------------------------
// -------------------------------------------------------------
/**
 * 案場名稱 取得 案場詳細資料 [ data ]
 * @param {string} factoryName '鳳山圳滯洪池'
 */
export var getLastDocumentApi = function getLastDocumentApi(factoryName) {
  return axios.post(Api.GetLastDocument, {
    factoryName: factoryName
  });
};

// -------------------------------------------------------------
// ---------------------- siteinfodetail -----------------------
// -------------------------------------------------------------
/**
 * 最近 30 天
 * @param {string} fId 'f001'
 */
export var getRecentThirtyDaysApi = function getRecentThirtyDaysApi(fId) {
  return axios.post(Api.GetRecentThirtyDays, {
    fId: fId
  });
};
/**
 * 時歷史
 * @param {string} todayDate '2023-02-08'
 * @param {string} fId 'f001'
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getHoursApi = function getHoursApi(todayDate, fId, siteName) {
  return axios.post(Api.GetHours, {
    todayDate: todayDate,
    fId: fId,
    siteName: siteName
  });
};
/**
 * 日歷史
 * @param {string} thisMon '2023-02'
 * @param {string} fId 'f001'
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getDaysApi = function getDaysApi(thisMon, fId, siteName) {
  return axios.post(Api.GetDays, {
    thisMon: thisMon,
    fId: fId,
    siteName: siteName
  });
};
/**
 * 月歷史
 * @param {string} thisYear '2023'
 * @param {string} fId fId 'f001'
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getMonthApi = function getMonthApi(thisYear, fId, siteName) {
  return axios.post(Api.GetMonth, {
    thisYear: thisYear,
    fId: fId,
    siteName: siteName
  });
};
/**
 * 年歷史
 * @param {string} fId fId 'f001'
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getYearApi = function getYearApi(fId, siteName) {
  return axios.post(Api.GetYear, {
    fId: fId,
    siteName: siteName
  });
};
/**
 * 變流器歷史
 * @param {string} date '2023-02-08'
 * @param {string} invNum 6
 * @param {string} fId 'f001'
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getInvsApi = function getInvsApi(date, invNum, fId, siteName) {
  return axios.post(Api.GetInvs, {
    date: date,
    invNum: invNum,
    fId: fId,
    siteName: siteName
  });
};

// -------------------------------------------------------------
// ------------------------- tv screen -------------------------
// -------------------------------------------------------------
/**
 * tv screen 群組數
 * @param {string} linkGroupNumber '16'
 */
export var getLinkGroupApi = function getLinkGroupApi(linkGroupNumber) {
  return axios.post(Api.GetLinkGroup, {
    linkGroupNumber: linkGroupNumber
  });
};

/**
 * tv screen 群組內之案場，各別取得資料
 * @param {string} factoryName '生利二期13區'
 * @param {string} id 'f142'
 * @param {string} thisMon '2023-02'
 */
export var getLinkDataApi = function getLinkDataApi(factoryName, id, thisMon) {
  return axios.post(Api.GetLinkData, {
    factoryName: factoryName,
    id: id,
    thisMon: thisMon
  });
};

/**
 * tv screen 案場照片
 * @param {string} id 'f142'
 * @returns data: ['照片連結網址']
 */
export var getLinkBlobApi = function getLinkBlobApi(id) {
  return axios.post(Api.GetLinkBlob, {
    id: id
  });
};

// -------------------------------------------------------------
// ------------------------ devicehistory ----------------------
// -------------------------------------------------------------
/**
 * 裝置歷史資料
 * @param {string} fId 'f001'
 * @param {string} factoryName '鳳山圳滯洪池'
 * @param {string} inv '0'
 * @param {string} startDate '2023-02-16'
 * @param {string} endDate '2023-02-17'
 */
export var getDeviceHistoryApi = function getDeviceHistoryApi(fId, factoryName, inv, date) {
  return axios.post(Api.GetDeviceHistory, {
    fId: fId,
    factoryName: factoryName,
    inv: inv,
    date: date
  });
};

// -------------------------------------------------------------
// ------------------------- dataanalysis ----------------------
// -------------------------------------------------------------
/**
 * 資料分析 analysis data 每 15 min
 * @param {string} fId 'f001'
 * @param {string} date '2023-02-08'
 */
export var getIntervalAnalysisApi = function getIntervalAnalysisApi(fId, date) {
  return axios.post(Api.GetIntervalAnalysis, {
    fId: fId,
    date: date
  });
};

/**
 * 資料分析 all analysis data
 * @param {string} siteName '鳳山圳滯洪池'
 * @param {string} fId 'f001'
 * @param {string} date '2023-02-08'
 */
export var getAllAnalysisDataApi = function getAllAnalysisDataApi(siteName, fId, date) {
  return axios.post(Api.GetAllAnalysisData, {
    siteName: siteName,
    fId: fId,
    date: date
  });
};

/**
 * 資料分析 availability data
 * @param {string} siteName '鳳山圳滯洪池'
 * @param {string} fId 'f001'
 * @param {string} date '2023-02-08'
 */
export var getAnalysisAvailabilityApi = function getAnalysisAvailabilityApi(siteName, fId, date) {
  return axios.post(Api.GetAnalysisAvailability, {
    siteName: siteName,
    fId: fId,
    date: date
  });
};

/**
 * 資料分析 取得 availability remarks
 * @param {string} fId 'f001'
 */
export var getAvailabilityRemarkApi = function getAvailabilityRemarkApi(fId) {
  return axios.post(Api.GetAvailabilityRemark, {
    fId: fId
  });
};

/**
 * 資料分析 更新 availability remarks
 * @param {string} fId 'f001'
 * @param {string} remarks [['2024-02', 'xxxx 備註文字']]
 */
export var updateAvailabilityRemarkApi = function updateAvailabilityRemarkApi(fId, remarks) {
  return axios.post(Api.UpdateAvailabilityRemark, {
    fId: fId,
    remarks: remarks
  });
};

// -------------------------------------------------------------
// ------------------------- mpptanalysis ----------------------
// -------------------------------------------------------------

/**
 * MPPT 分析 mppt 數量
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getMpptLenApi = function getMpptLenApi(siteName) {
  return axios.post(Api.GetMpptLen, {
    siteName: siteName
  });
};

/**
 * MPPT 分析 data
 * @param {string} siteName '鳳山圳滯洪池'
 * @param {string} beginTime '13:30'
 * @param {string} endTime '13:31'
 * @param {string} date '2023-02-15'
 * @param {string} fId 'f001'
 */
export var getMpptDataApi = function getMpptDataApi(siteName, beginTime, endTime, date, fId) {
  return axios.post(Api.GetMpptData, {
    siteName: siteName,
    beginTime: beginTime,
    endTime: endTime,
    date: date,
    fId: fId
  });
};

// -------------------------------------------------------------
// -------------------------- dataexcel ------------------------
// -------------------------------------------------------------
/**
 * 設計資訊 - 串接資料、PVsyst
 * @param {string} fileName '鳳山圳滯洪池_串列資料.json'
 */
export var getCsvApi = function getCsvApi(fileName) {
  return axios.post(Api.GetCsv, {
    fileName: fileName
  });
};

/**
 * 設計資訊 - PVsyst
 * @param {string} fileName '鳳山圳滯洪池_PVSYS.json'
 * @param {string[]} csvHeader ['','',...]
 * @param {Array<object>} csvData [{},{},...]
 * @returns msg: 'OK'
 */
export var updateCsvApi = function updateCsvApi(fileName, csvHeader, csvData) {
  return axios.put(Api.UpdateCsv, {
    csvData: {
      fileName: fileName,
      csvHeader: csvHeader,
      csvData: csvData
    }
  });
};

/**
 * 設計資訊 - 檔案資料
 * @param {string} factoryId 'f001'
 */
export var getPdfApi = function getPdfApi(factoryId) {
  return axios.post(Api.GetPdf, {
    factoryId: factoryId
  });
};

/**
 * 設計資訊 - 檔案資料 刪除
 * @param {string} factoryName '鳳山圳滯洪池'
 * @param {string} pdfName '鳳山圳滯洪池_系統單線圖-高雄市-鳳山圳(二期)-00-20200205.pdf'
 */
export var deletePdfApi = function deletePdfApi(factoryName, pdfName) {
  return axios.delete(Api.DeletePdf, {
    data: {
      factoryName: factoryName,
      pdfName: pdfName
    }
  });
};

/**
 * 設計資訊 - KPI 設定
 * @param {string} filename '鳳山圳滯洪池.json'
 */
export var getKpiTableApi = function getKpiTableApi(filename) {
  return axios.post(Api.GetKpiTable, {
    filename: filename
  });
};

/**
 * 設計資訊 - KPI 設定 新增
 * @param {string} filename '鳳山圳滯洪池.json'
 * @param {Array<object>} tables [{},{},...]
 */
export var createKpiTableApi = function createKpiTableApi(filename, tables) {
  return axios.post(Api.CreateKpiTable, {
    filename: filename,
    tables: tables
  });
};

// -------------------------------------------------------------
// ---------------------- investmentanalysis -------------------
// -------------------------------------------------------------
/**
 * 投資分析 - 發電量
 * @param {string} fId 'f001'
 * @param {string} kpiFilename '鳳山圳滯洪池.json'
 * @param {string[]} months ['2022-05','2022-06', ...]
 */
export var getPowerAmountApi = function getPowerAmountApi(fId, kpiFilename, months) {
  return axios.post(Api.GetPowerAmount, {
    fId: fId,
    kpiFilename: kpiFilename,
    months: months
  });
};

/**
 * 投資分析 - 發電收入
 * @param {string} fId 'f001'
 * @param {string} kpiFilename '鳳山圳滯洪池.json'
 * @param {string[]} months ['2022-05','2022-06', ...]
 */
export var getPowerRevenueApi = function getPowerRevenueApi(fId, kpiFilename, months) {
  return axios.post(Api.GetPowerRevenue, {
    fId: fId,
    kpiFilename: kpiFilename,
    months: months
  });
};

/**
 * 投資分析 - 妥善率
 * @param {string} fId 'f001'
 * @param {string} kpiFilename '鳳山圳滯洪池.json'
 * @param {string[]} months ['2022-05','2022-06', ...]
 */
export var getAvailabilityApi = function getAvailabilityApi(fId, kpiFilename, months) {
  return axios.post(Api.GetAvailability, {
    fId: fId,
    kpiFilename: kpiFilename,
    months: months
  });
};

/**
 * 投資分析 - PR 值
 * @param {string} fId 'f001'
 * @param {string} kpiFilename '鳳山圳滯洪池.json'
 * @param {string[]} months ['2022-05','2022-06', ...]
 */
export var getPerformantRateApi = function getPerformantRateApi(fId, kpiFilename, months) {
  return axios.post(Api.GetPerformantRate, {
    fId: fId,
    kpiFilename: kpiFilename,
    months: months
  });
};

/**
 * 投資分析 - 監控值與電費單比較
 * @param {string} fId 'f001'
 * @param {string} fName '鳳山圳滯洪池'
 */
export var getBillsApi = function getBillsApi(fId, fName) {
  return axios.post(Api.GetBills, {
    fId: fId,
    fName: fName
  });
};

/**
 * 投資分析 - 監控值與電費單比較
 * @param {string} fName '鳳山圳滯洪池'
 * @param {Array<object>} data [{},{},...]
 */
export var getWriteBillsApi = function getWriteBillsApi(fName, data) {
  return axios.post(Api.GetWriteBills, {
    fName: fName,
    data: data
  });
};

/**
 * 投資分析 - 資料妥善率
 * @param {string} fId 'f001'
 * @param {string[]} months ['2024-01', '2024-02', ...]
 */
export var getDataRetentionApi = function getDataRetentionApi(fId, months) {
  return axios.post(Api.GetDataRetention, {
    fId: fId,
    months: months
  });
};

// -------------------------------------------------------------
// ----------------------- Monthlyreport -----------------------
// -------------------------------------------------------------
/**
 * 案場報表 (月)
 * @param {string} fId 'f001'
 * @param {string} date '2023-01'
 */
export var getMonSumTableApi = function getMonSumTableApi(fId, date) {
  return axios.post(Api.GetMonSumTable, {
    fId: fId,
    date: date
  });
};

/**
 * 案場報表 (月)
 * @param {string} fId 'f001'
 * @param {string} date '2023-01'
 */
export var getDaysTableApi = function getDaysTableApi(fId, date) {
  return axios.post(Api.GetDaysTable, {
    fId: fId,
    date: date
  });
};

/**
 * 案場報表 (月)
 * @param {string} fId 'f001'
 * @param {string} date '2023-01'
 */
export var getDaysChartApi = function getDaysChartApi(fId, date) {
  return axios.post(Api.GetDaysChart, {
    fId: fId,
    date: date
  });
};
/**
 * 案場報表 (年)
 * @param {string} fId 'f001'
 * @param {string} date '2023'
 */
export var getYearSumTableApi = function getYearSumTableApi(fId, date) {
  return axios.post(Api.GetYearSumTable, {
    fId: fId,
    date: date
  });
};

/**
 * 案場報表 (年)
 * @param {string} fId 'f001'
 * @param {string} date '2023'
 */
export var getMonthsTableApi = function getMonthsTableApi(fId, date) {
  return axios.post(Api.GetMonthsTable, {
    fId: fId,
    date: date
  });
};

/**
 * 案場報表 (年)
 * @param {string} fId 'f001'
 * @param {string} date '2023'
 */
export var getMonthsChartApi = function getMonthsChartApi(fId, date) {
  return axios.post(Api.GetMonthsChart, {
    fId: fId,
    date: date
  });
};

// -------------------------------------------------------------
// -------------------- NotificationSettings -------------------
// -------------------------------------------------------------

/**
 *
 * @param {string} factoryName '鳳山圳滯洪池'
 * @returns
 */
export var getCustomAlarmApi = function getCustomAlarmApi(factoryName) {
  return axios.post(Api.GetCustomAlarm, {
    factoryName: factoryName
  });
};

/**
 *
 * @param {object} data 檢查是否為 Notification 通知設定指南 所設定的群組名稱
 *  {
 *    [key]: '群組名稱1', // key: mailGroup / lineGroup / telegramGroup...
 *  }
 * @returns
 */
export var getCustomAlarmGroupApi = function getCustomAlarmGroupApi(data) {
  return axios.post(Api.GetCustomAlarmGroup, data);
};

/**
 *
 * @param {string} factoryName '鳳山圳滯洪池'
 * @param {object} cutstomAlarm
 *  {
 *    mailGroup: ['群組名稱1', '群組名稱2', ...],
 *    lineGroup: [],
 *    telegramGroup: [],
 *    SMSGroup: [],
 *    phoneCallGroup: [],
 *    alarmList: [6, "rstAllNoPower", "prSevenDayAverageLower80"]
 *  }
 * @returns
 */
export var updateCustomAlarmApi = function updateCustomAlarmApi(_ref) {
  var factoryName = _ref.factoryName,
    customAlarm = _ref.customAlarm;
  return axios.post(Api.UpdateCustomAlarm, {
    factoryName: factoryName,
    customAlarm: customAlarm
  });
};

// -------------------------------------------------------------
// ---------------------------- DIDO ---------------------------
// -------------------------------------------------------------
export var getDidoApi = function getDidoApi(factoryName) {
  return axios.get(Api.GetDido, {
    params: {
      factoryName: factoryName
    }
  });
};
export var writeDidoApi = function writeDidoApi(data) {
  return axios.post(Api.WriteDido, data);
};

// export const updateDidoApi = (data) => axios.put(Api.UpdateDido, data)
export var updateDidoApi = function updateDidoApi(_ref2) {
  var id = _ref2.id,
    factoryName = _ref2.factoryName,
    deviceId = _ref2.deviceId,
    mapping = _ref2.mapping;
  return axios.put(Api.UpdateDido, {
    id: id,
    factoryName: factoryName,
    deviceId: deviceId,
    mapping: mapping
  });
};
export var dmDidoApi = function dmDidoApi(_ref3) {
  var operation = _ref3.operation,
    deviceId = _ref3.deviceId,
    srcName = _ref3.srcName,
    tag = _ref3.tag,
    dataValue = _ref3.dataValue;
  return axios.post(Api.DirectMethodDido, {
    operation: operation,
    deviceId: deviceId,
    srcName: srcName,
    tag: tag,
    dataValue: dataValue
  });
};

// export const deleteDidoApi = ({ id, factoryName }) =>
//   axios.delete(Api.DeleteDido, { params: { id, factoryName } })

// -------------------------------------------------------------
// ----------------------- factoryStatus -----------------------
// -------------------------------------------------------------
/**
 * 案場即時狀態
 */
export var getRecentAlarmsApi = function getRecentAlarmsApi() {
  return axios.post(Api.GetRecentAlarms);
};

/**
 * 案場裝置設定上傳
 * @param {string} factoryName '鳳山圳滯洪池'
 * @param {string} docId 'f001'
 * @param {object} deviceConfig {}
 */
export var updateDeviceConfigApi = function updateDeviceConfigApi(factoryName, docId, deviceConfig) {
  return axios.put(Api.UpdateDeviceConfig, {
    factoryName: factoryName,
    docId: docId,
    deviceConfig: deviceConfig
  });
};

/**
 * 案場裝置狀態 電表資料
 * @param {string} siteName '鳳山圳滯洪池'
 */
export var getLastEtcDataApi = function getLastEtcDataApi(factoryName) {
  return axios.post(Api.GetLastEtcData, {
    factoryName: factoryName
  });
};

// -------------------------------------------------------------
// ----------------------- historyalarms -----------------------
// -------------------------------------------------------------
/**
 * 告警事件 案場歷史狀態
 */
export var getHistoryAlarmsApi = function getHistoryAlarmsApi() {
  return axios.post(Api.GetHistoryAlarms);
};

// -------------------------------------------------------------
// ------------------------- usermanage -----------------------
// -------------------------------------------------------------
/**
 * user 清單, 可看 users
 */
export var getAllUsersApi = function getAllUsersApi() {
  return axios.post(Api.GetAllUsers);
};

/**
 * 新增帳號
 * @param {string} operator ''
 * @param {string} account ''
 * @param {string} password ''
 * @param {string} displayName '稱呼'
 * @param {string} role 'Admin(權限)'
 * @param {string[]} factoriesList 可觀看案場 ['','']
 * @param {string[]} demoList 可觀看展示案場 ['','']
 * @param {string} applicant '創建者帳號'
 * @returns msg: 'user xxx created'
 */
export var createUserApi = function createUserApi(operator, account, password, displayName, role, factoriesList, demoList, applicant) {
  return axios.post(Api.CreateUser + "".concat(operator), {
    operator: operator,
    account: account,
    password: password,
    displayName: displayName,
    role: role,
    factoriesList: factoriesList,
    demoList: demoList,
    applicant: applicant
  });
};

/**
 * 更新帳號
 * @param {string} operator ''
 * @param {string} id ''
 * @param {string} account ''
 * @param {string} password ''
 * @param {string} displayName '稱呼'
 * @param {string} role 'Admin(權限)'
 * @param {string[]} factoriesList 可觀看案場 ['','']
 * @param {string[]} demoList 可觀看展示案場 ['','']
 * @returns msg: 'OK'
 */
export var updateAccountApi = function updateAccountApi(operator, id, account, password, displayName, role, factoriesList, demoList) {
  return axios.put(Api.UpdateAccount + "".concat(operator), {
    operator: operator,
    id: id,
    account: account,
    password: password,
    displayName: displayName,
    role: role,
    factoriesList: factoriesList,
    demoList: demoList
  });
};

/**
 * 刪除帳號
 * @param {string} operator 'userName'
 * @param {string} id 'id'
 * @param {string} account 'account'
 * @returns msg: 'xxx deleted'
 */
export var deleteUserApi = function deleteUserApi(operator, id, account) {
  return axios.delete(Api.DeleteUser + "".concat(operator), {
    data: {
      id: id,
      account: account
    }
  });
};

// -------------------------------------------------------------
// ------------------------- groupmanage -----------------------
// -------------------------------------------------------------
/**
 * role 清單, role 可看 menu
 */
export var getAllGroupsApi = function getAllGroupsApi() {
  return axios.post(Api.GetAllGroups);
};

/**
 * 新增群組
 * @param {string} operator 'userName'
 * @param {string} role 'groupName'
 * @param {string[]} sideMenu ['','']
 * @param {string[]} componentMenu ['','']
 * @param {string[]} othersMenu ['','']
 * @param {object[]} otherSites
 * {
 *    name: 'projectEnergy',
 *    sideMenu: ['',''],
 *    componentMenu: ['',''],
 *    othersMenu: ['','']
 * }
 * @returns msg: 'OK'
 */
export var createGroupApi = function createGroupApi(operator, role, sideMenu, componentMenu, othersMenu, otherSites) {
  return axios.post(Api.CreateGroup + "".concat(operator), {
    role: role,
    sideMenu: sideMenu,
    componentMenu: componentMenu,
    othersMenu: othersMenu,
    otherSites: otherSites
  });
};

/**
 * 更新群組
 * @param {string} id 'id'
 * @param {string} operator 'userName'
 * @param {string} role 'groupName'
 * @param {string[]} sideMenu ['','']
 * @param {string[]} componentMenu ['','']
 * @param {string[]} othersMenu ['','']
 * @returns msg: 'OK'
 */
export var updateGroupApi = function updateGroupApi(id, operator, role, sideMenu, componentMenu, othersMenu, otherSites) {
  return axios.put(Api.UpdateGroup + "".concat(operator), {
    id: id,
    role: role,
    sideMenu: sideMenu,
    componentMenu: componentMenu,
    othersMenu: othersMenu,
    otherSites: otherSites
  });
};

/**
 * 刪除群組
 * @param {string} operator 'userName'
 * @param {string} role 'groupName'
 * @param {string} id 'id'
 * @returns msg: 'OK'
 */
export var deleteGroupApi = function deleteGroupApi(operator, role, id) {
  return axios.delete(Api.DeleteGroup + "".concat(operator), {
    data: {
      role: role,
      id: id
    }
  });
};

// -------------------------------------------------------------
// -------------------------- emailsend ------------------------
// -------------------------------------------------------------
/**
 * 信件補發 業主案場清單、群組名稱
 */
export var getDailyReportListApi = function getDailyReportListApi() {
  return axios.post(Api.GetDailyReportList);
};

/**
 * 信件補發 案場資訊
 * @param {string} group 'Wuri.High.Speed.Rail'
 * @param {string} date '2023-02-15'
 */
export var getDailyReportApi = function getDailyReportApi(group, date) {
  return axios.post(Api.GetDailyReport, {
    group: group,
    date: date
  });
};

/**
 * 信件補發 信件寄送
 * @param {string} group 'Wuri.High.Speed.Rail'
 * @param {string} date '2023-02-15'
 * @param {Array<object>} reportData 寄件報告 [{}]
 * @param {string[]} mails 寄件人 ['','',...]
 */
export var getSendMailsApi = function getSendMailsApi(group, date, reportData, mails) {
  return axios.post(Api.GetSendMails, {
    group: group,
    date: date,
    reportData: reportData,
    mails: mails
  });
};

// -------------------------------------------------------------
// ------------------- multiplefactoryanalysis -----------------
// -------------------------------------------------------------
/**
 * 跨案場分析 - 時
 * @param {Array<object>} data
 * [
 *    { fId: 'f001',
 *      siteName: '鳳山圳滯洪池',
 *      todayDate: '2023-02-16' },
 *    {},
 *    ...
 * ]
 */
export var getMultipleHourDataApi = function getMultipleHourDataApi(data) {
  return axios.post(Api.GetMultipleHourData, data);
};

/**
 * 跨案場分析 - 日
 * @param {Array<object>} data
 * [
 *    { fId: 'f001',
 *      siteName: '鳳山圳滯洪池',
 *      beginDate: '2023-02-16',
 *      endDate: '2023-02-16' },
 *    {},
 *    ...
 * ]
 */
export var getMultipleDayDataApi = function getMultipleDayDataApi(data) {
  return axios.post(Api.GetMultipleDayData, data);
};

/**
 * 跨案場分析 - 月
 * @param {Array<object>} data
 * [
 *    { fId: 'f001',
 *      siteName: '鳳山圳滯洪池',
 *      beginDate: '2023-02',
 *      endDate: '2023-02' },
 *    {},
 *    ...
 * ]
 */
export var getMultipleMonthDataApi = function getMultipleMonthDataApi(data) {
  return axios.post(Api.GetMultipleMonthData, data);
};

/**
 * 跨案場分析 - 年
 * @param {Array<object>} data
 * [
 *    { fId: 'f001',
 *      siteName: '鳳山圳滯洪池',
 *      beginDate: '2023',
 *      endDate: '2023' },
 *    {},
 *    ...
 * ]
 */
export var getMultipleYearDataApi = function getMultipleYearDataApi(data) {
  return axios.post(Api.GetMultipleYearData, data);
};

// -------------------------------------------------------------
// ---------------------- rawdatadownload ----------------------
// -------------------------------------------------------------
/**
 * 原始資料下載
 * @param {string} site '鳳山圳滯洪池_f001'
 * @param {string} date '2023-02-09'
 */
export var getRawDataApi = function getRawDataApi(site, date) {
  return axios.post(Api.GetRawData, {
    site: site,
    date: date
  });
};

// -------------------------------------------------------------
// ------------------------- raanalysis -----------------------
// -------------------------------------------------------------
/**
 * RA 資料分析
 * @param {string} fId 'f108'
 * @param {string} factoryName '奇加企業'
 * @param {string} timeStart '2023-02-11T16:00:00+08:00'
 * @param {string} timeEnd '2023-02-11T17:00:00+08:00'
 */
export var getPvRaApi = function getPvRaApi(fId, factoryName, timeStart, timeEnd) {
  return axios.post(Api.GetPvRa, {
    fId: fId,
    factoryName: factoryName,
    timeStart: timeStart,
    timeEnd: timeEnd
  });
};
export var getAerialComparisonApi = function getAerialComparisonApi(factoryName, fId, date, time) {
  return axios.post(Api.GetAerialComparison, {
    factoryName: factoryName,
    fId: fId,
    date: date,
    time: time
  });
};

// -------------------------------------------------------------
// ------------------------- kpireport ------------------------
// -------------------------------------------------------------
/**
 * RA 資料分析
 * @param {string} date '2024-03'
 */
export var getKpiApi = function getKpiApi(date) {
  return axios.post(Api.GetKpi, {
    date: date
  });
};

// -------------------------------------------------------------
// ------------------------- 富強鑫 fuqiangxindemo --------------
// -------------------------------------------------------------
export var getFuqiangxinApi = function getFuqiangxinApi() {
  return axios.post(Api.GetFuqiangxin);
};

// -------------------------------------------------------------
// ------------------------- 案場排序 sortsetting ---------------
// -------------------------------------------------------------
export var getSortedFactoriesApi = function getSortedFactoriesApi() {
  return axios.post(Api.GetSortedFactories);
};

/**
 * 案場排序列表上傳
 * @param {string[]} sortArray ['nameA', 'nameB', ...]
 */
export var updateSortedFactoriesApi = function updateSortedFactoriesApi(sortArray) {
  return axios.post(Api.UpdateSortedFactories, {
    sortArray: sortArray
  });
};

// -------------------------------------------------------------
// ------------------------- 電視牆輪播 tvwalllooping -----------
// -------------------------------------------------------------
export var get14fSelectedApi = function get14fSelectedApi() {
  return axios.post(Api.Get14fSelected);
};
export var get14fDataApi = function get14fDataApi(factoryName) {
  return axios.post(Api.Get14fData, {
    factoryName: factoryName
  });
};